import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice";
import modalReducer from "./features/modalSlice";
import venueReducer from "./features/venueSlice";
import hotelReducer from "./features/hotelSlice";
import bulkEnquiryReducer from "./features/bulkEnquirySlice";

const store = configureStore({
  reducer: {
    modal: modalReducer,
    auth: authReducer,
    venues: venueReducer,
    hotels: hotelReducer,
    bulkEnquiry: bulkEnquiryReducer,
    
    // other reducers can be added here
  },
});

export default store;
